import { type TabProps } from "./types";

export function Tab({ children }: TabProps) {
  return <>{children}</>;
}
